<template>
  <div>
    <article-queries v-if="project"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import ArticleQueries from '@/components/coding-admin/article-queries';
  export default {
    name: 'ProjectArticleQueries',
    components: {'article-queries': ArticleQueries},

    mounted() {
      const projectUid = this.$route.params.project_uid;
      // this.$emit('setHeaderPrimaryName', this.project.project_name);
    },

    computed: {
      ...mapState({
        user: state => state.user.user.data,
        project: state => state.projects.project.data
      }),
    },
  };
</script>